/**
 * Translations are rendered by @mellowScripts from lang/{locale}/ui.php so that
 * client-side strings (aria labels, announcements…) follow the app locale.
 */
export function createTranslator(strings = {}) {
    return (key, replace = {}) => {
        let line = key.split('.').reduce((value, part) => value?.[part], strings) ?? key;
        for (const [name, value] of Object.entries(replace)) {
            line = line.replaceAll(`:${name}`, value);
        }
        return line;
    };
}
